import { render, staticRenderFns } from "./ResponsiveSearchComponent.vue?vue&type=template&id=23148203&"
import script from "./ResponsiveSearchComponent.vue?vue&type=script&lang=js&"
export * from "./ResponsiveSearchComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports